import React, { Component } from 'react'
import { connect } from 'react-redux'

import { translation } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'

import { closeOverlay } from '../../../actions/common'

import Modal from '../../components/Modal'

// elements
import { ModalIcons } from '../../elements/icons'
import Row from '../../elements/row'
import Col from '../../elements/col'
import Grid from '../../elements/grid'
// import Divider from '../../elements/divider'

// styles
import './carrentalcontractmodal.scss'

class CarRentalContractModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
    this.printContract = this.printContract.bind(this)
    this.onAfterPrint = this.onAfterPrint.bind(this)
  }

  renderLender () {
    const { Company } = this.props.contract
    return (
      <div className='section'>
        <div className='section__title'>{translation(16782)}</div>
        <div>{Company.Name}</div>
        <div>{Company.Address}</div>
        <div>{Company.Zip}</div>
        <div>{Company.City}</div>
        <Grid>
          <span>{translation(41)}</span>
          <span>{Company.CVR}</span>
        </Grid>
      </div>
    )
  }

  renderRenter () {
    const { Renter } = this.props.contract

    const renderPhones = (val, key) => {
      return (
        <div key={key}>{val}</div>
      )
    }

    return (
      <div className='section'>
        <div className='section__title'>{translation(16783)}</div>
        <div>{Renter.Name}</div>
        <div>{Renter.Address}</div>
        <div>{Renter.Zip}</div>
        <div>{Renter.City}</div>
        {Renter.Phones.map(renderPhones)}
        <div>{Renter.Mail}</div>
        <Grid>
          <span>{translation(16795)}</span>
          <span>{Renter.DriverLicense}</span>
        </Grid>
        <Grid>
          <span>{translation(41)}</span>
          <span>{Renter.CVR}</span>
        </Grid>
      </div>
    )
  }

  renderCar () {
    const { Car } = this.props.contract
    return (
      <div className='section'>
        <div className='section__title'>{translation(629)}</div>
        <Grid>
          <span>{translation(16792)}</span>
          <span>{Car.Nr}</span>
        </Grid>
        <Grid>
          <span>{translation(2005)}</span>
          <span>{Car.RegNumber}</span>
        </Grid>
        <Grid>
          <span>{translation(145)}</span>
          <span>{Car.Brand}</span>
        </Grid>
        <Grid>
          <span>{translation(146)}</span>
          <span>{Car.Model}</span>
        </Grid>
      </div>
    )
  }

  renderPeriods () {
    const { Periods } = this.props.contract

    const getDate = (dateTime) => { return dateTime.split(' - ')[0] }
    const getTime = (dateTime) => { return dateTime.split(' - ')[1] }

    const renderPeriod = (p, i) => {
      let start = renderFullDate(p.Start)
      let end = renderFullDate(p.End)

      return (
        <div key={'period_' + i}>
          <Grid>
            <span>{translation(16771)}</span>
            <span>{`${getDate(start)} ${getTime(start)}`}</span>
          </Grid>
          <Grid>
            <span>{translation(16772)}</span>
            <span>{`${getDate(end)} ${getTime(end)}`}</span>
          </Grid>
        </div>
      )
    }
    return (
      <div className='section'>
        <div className='section__title'>{translation(16784)}</div>
        {Periods.map(renderPeriod)}
      </div>
    )
  }

  renderRent () {
    const { Rent } = this.props.contract
    return (
      <div className='section'>
        <div className='section__title'>{translation(16785)}</div>
        <Grid>
          <span>{translation(16797)}</span>
          <span>{Rent.Fuel ? translation(47) : translation(48)}</span>
        </Grid>
        <Grid>
          <span>{translation(16798)}</span>
          <span>{Rent.Tank}</span>
        </Grid>
        <Grid>
          <span>{translation(16800)}</span>
          <span>{Rent.UpToKm}</span>
        </Grid>
        <Grid>
          <span>{translation(16801)}</span>
          <span>{Rent.ExtraKm}</span>
        </Grid>
      </div>
    )
  }

  renderHandover () {
    const { KmAtStart } = this.props.contract
    return (
      <div className='section'>
        <div className='section__title'>{translation(16787)}</div>
        <Grid>
          <span>{translation(16802)}</span>
          <span>{KmAtStart}</span>
        </Grid>
      </div>
    )
  }

  renderInsurance () {
    const { Insurance } = this.props.contract
    return (
      <div className='section'>
        <div className='section__title'>{translation(16786)}</div>
        <Grid>
          <span>{translation(16793)}</span>
          <span>{Insurance.Kasko ? translation(47) : translation(48)}</span>
        </Grid>
        <Grid>
          <span>{translation(16794) + ' ' + translation(this.props.currencyCode) + ' ' + Insurance.SelfRiskCoverageAmount + ' ' + translation(971)}</span>
          <span>{Insurance.SelfRiskCoverage ? translation(47) : translation(48)}</span>
        </Grid>
      </div>
    )
  }

  renderDrivers () {
    const { Drivers } = this.props.contract
    const mapDrivers = (val, key) => {
      return (
        <div className='spacing'>
          <span>{val.Name}</span>
          <Grid key={key}>
            <span>{translation(16795)}</span>
            <span>{val.DriverLicense}</span>
          </Grid>
        </div>
      )
    }
    return (
      <div className='section'>
        <div className='section__title'>{translation(16788)}</div>
        {Drivers.map(mapDrivers)}
      </div>
    )
  }

  renderConditions () {
    const { Conditions } = this.props.contract
    return (
      <div className='section conditions'>
        <div className='section__title'>{translation(16789)}</div>
        {Conditions}
      </div>
    )
  }

  renderSignature () {
    return (
      <div className='section'>
        <div>{`${translation(16806)} ${translation(16807)} ${translation(16808)}`}</div>
        <div className='section__signature'>
          <Grid cols={[0.5, 1]}>
            <div>
              <div className='line' />
              <div>{translation(388)}</div>
            </div>
            <div>
              <div className='line' />
              <div>{translation(16783)}</div>
            </div>
          </Grid>
        </div>
      </div>
    )
  }

  onAfterPrint () {
    // close all, back to workcard
    this.props.onClose()
    this.props.closeOverlay('CarRentalContractOverlay', true)
  }

  printContract () {
    window.print()
    if (window.matchMedia) {
      var mediaQueryList = window.matchMedia('print')
      console.log('mediaQueryList ', mediaQueryList)
      mediaQueryList.addListener((mql) => {
        console.log('mql ', mql)
        if (!mql.matches) {
          this.onAfterPrint()
        }
      })
    }
    window.onafterprint = this.onAfterPrint()
  }

  render () {
    let bottomBarProps = {
      actionLabelText: translation(16805),
      onActionClick: this.printContract,
      center: true
    }
    return (
      <div className='carrentalcontract_modal'>
        <Modal
          show={this.props.show}
          onClose={this.props.onClose}
          header={translation(16781)}
          icon={ModalIcons.CarRental}
          bottomBarProps={bottomBarProps}
          overflowHidden>
          <div className='contract__content'>
            <Row>
              <Col>
                {this.renderLender()}
                {this.renderRenter()}
                {this.renderInsurance()}
                {this.renderDrivers()}
              </Col>
              <Col>
                {this.renderCar()}
                {this.renderPeriods()}
                {this.renderRent()}
                {this.renderHandover()}
              </Col>
            </Row>
            <Row>
              <Col span={3}>
                {this.renderConditions()}
                {this.renderSignature()}
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
  }
}

export default connect(mapStateToProps, {closeOverlay}
)(CarRentalContractModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/CarRentalContractModal/index.js